import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { authForgotPassword } from "../../../redux/features/coach/actions/authAction";
import { coachPaths } from "../../../routes/coach";
import { Formik } from "formik";
import { forgotPasswordSchema } from "../../../utils/schema";
import ErrorMessage from "../../form/ErrorMessage";
import Loader from "../../loader";

const CoachForgotPassword = ({
  backToLogin,
  onClose,
  otpScreen,
  setData,
  isLoad,
  setIsLoad,
  onForgot,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialValues = {
    email: "",
  };

  const handleSubmitEmail = (values) => {
    setIsLoad(true);
    const callback = (response) => {
      setIsLoad(false);
      if (response.success) {
        otpScreen();
        setData(response?.data, values?.email);
      } else {
        onForgot();
      }
    };
    dispatch(authForgotPassword({ payload: values, callback }));
  };
  if (isLoad) {
    return <Loader />;
  }
  return (
    <div
      className="modal d-block ct_large_modal_width ct_congratulation_modal_fade"
      tabIndex="-1"
    >
      <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
        <div class="modal-content">
          <div class="modal-header border-0 p-0 pb-2">
            <button
              type="button"
              class="btn-close ct_close_position_right12"
              onClick={onClose}
            ></button>
          </div>
          <div class="modal-body pe-0">
            <section class="ct_signup_main py-3">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                    <div class="ct_signup_left_img">
                      <img src="../assets/img/login_coach.png" alt="" />
                    </div>
                  </div>
                  <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 mx-auto pe-0">
                    <div class="ct_signup_right_content px-5 ct_custom_scroll">
                      <div class="ct_signup_logo mb-3">
                        <img src="../assets/img/Nuvio_logo.png" alt="" />
                      </div>
                      <div class="mt-0 ">
                        <h2 class="ct_fs_32  mb-2 ct_darkblue_text text-center">
                          Forgot Password
                        </h2>
                        <p
                          class="mb-0 ct_darkblue_text mx-auto"
                          style={{ maxWidth: "454px" }}
                        >
                          No worries, we'll send you instructions to reset your
                          password shortly
                        </p>
                      </div>
                      <Formik
                        initialValues={initialValues}
                        validationSchema={forgotPasswordSchema}
                        onSubmit={(values, actions) => {
                          handleSubmitEmail(values);
                        }}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          setFieldValue,
                        }) => (
                          <form onSubmit={handleSubmit} class="mt-4">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="form-group mb-4">
                                  <label
                                    for=""
                                    class="mb-2 d-block ct_darkblue_text"
                                  >
                                    {" "}
                                    Email
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control ct_input"
                                    placeholder="Email"
                                    id="email"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.email}
                                  />
                                  <ErrorMessage
                                    errors={errors}
                                    touched={touched}
                                    fieldName="email"
                                  />
                                </div>
                              </div>
                              
                            </div>
                            <div class="text-center mt-2">
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleSubmit();
                                }}
                                class="ct_yellow_btn w-75 mx-auto"
                              >
                                Reset Password{" "}
                              </a>
                            </div>
                          </form>
                        )}
                      </Formik>
                      <div class="ct_back_login_text text-center mt-3">
                        <a onClick={backToLogin} class="mb-0 ct_darkblue_text">
                          <i class="fa-solid fa-arrow-left"></i> Back to Log in
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoachForgotPassword;
